export default "__VITE_ASSET__BpAcIOAy__"